/* istanbul ignore file */
import React, { useEffect } from 'react';
import { FpLoading } from 'components/atoms/FpLoading';
import {
  AuthorizationServiceConfiguration,
  FetchRequestor,
} from '@openid/appauth';
import environment from 'environment';
import { useUserReadFacade } from 'redux/user-read/user-read.facade';

export function FpLogout() {
  const { idToken } = useUserReadFacade();

  useEffect(() => {
    // .well-knownエンドポイントからOIDCのエンドポイント情報を取得
    const postLogoutRedirectUri = encodeURIComponent(environment.postLogoutRedirectUri);
    AuthorizationServiceConfiguration.fetchFromIssuer(environment.OPServer, new FetchRequestor())
      .then((response) => {
        window.location.href = `${response.endSessionEndpoint}/?post_logout_redirect_uri=${postLogoutRedirectUri}&id_token_hint=${idToken}`;
      }).catch((error) => {
        console.error(JSON.stringify(error));
      });
  });

  return (<FpLoading />);
}
